import { createFileRoute } from '@tanstack/react-router'
import Component from './-module-components/component'

export const Route = createFileRoute('/manager/_layout/sales-and-revenue/')({
  component: Component,
})